import type { OutOfPageAdType } from '@/modules/adv/index'
import { AdProviderNames, type PlatformType } from '@/types'

type BannerSequenceConditions = {
    maxDurationSec?: number
    providers?: AdProviderNames[]
    platforms?: PlatformType[]
}

export type BannerSequenceConfig = Partial<
    Record<
        OutOfPageAdType,
        {
            nextType: OutOfPageAdType
            conditions: BannerSequenceConditions
        }
    >
>

export const bannerSequenceConfig: BannerSequenceConfig = {
    interstitial_preroll: {
        nextType: 'interstitial_preroll_2',
        conditions: {
            maxDurationSec: 10,
            providers: [AdProviderNames.GOOGLE_INSTREAM],
            platforms: ['desktop'],
        },
    },
    rewarded: {
        nextType: 'rewarded_2',
        conditions: {
            maxDurationSec: 25,
            providers: [AdProviderNames.GOOGLE_INSTREAM],
            platforms: ['desktop'],
        },
    },
}
